import Heading from "components/atoms/Heading";
import React from "react";
import { useLocation } from "react-router-dom";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";
interface WrapperPanelProps {
  children: React.ReactNode;
  modifiers?: Modifiers;
}
interface AsideProps {
  children: React.ReactNode;
  modifiers?: Modifiers;
  className?: string;
  asideClassName?: string;
  isShowFilter?: boolean;
}
interface MainContentProps {
  children: React.ReactNode;
  modifiers?: Modifiers;
}

const WrapperPanel: React.FC<WrapperPanelProps> = ({
  children,
  modifiers,
}: WrapperPanelProps) => (
  <main className={mapMultiClassnames("o-wrapper-panel", modifiers)}>
    {children}
  </main>
);

export const Aside: React.FC<AsideProps> = React.memo(
  ({
    children,
    modifiers,
    className,
    asideClassName,
    isShowFilter,
  }: AsideProps) => {
    const _classname = "o-wrapper-panel-aside";
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();

    return location.pathname.includes("/danh-muc") ? (
      <div
        className={joinClassnames(
          mapMultiClassnames(`${_classname}`, modifiers),
          className,
        )}
      >
        <div className={`${_classname}_desktop`}>
          {!isShowFilter && <Heading type="h3">Bộ lọc</Heading>}
          <aside className={asideClassName}>{children}</aside>
        </div>
      </div>
    ) : (
      <div
        className={joinClassnames(
          mapMultiClassnames(`${_classname}`, modifiers),
          className,
        )}
      >
        <aside className={asideClassName}>{children}</aside>
      </div>
    );
  },
);

export const MainContent: React.FC<MainContentProps> = React.memo(
  ({ children, modifiers }: MainContentProps) => {
    const _classname = "o-wrapper-panel-main-content";
    return (
      <section className={mapMultiClassnames(`${_classname}`, modifiers)}>
        {children}
      </section>
    );
  },
);

export default React.memo(WrapperPanel);
